import { ChartTimeframe, Exchange } from '@/types/generated/common/types'

/**
 * With `enterAtOneSecond` (Chart Settings → papertradeOneSecondEntryAtom), entering a
 * Papertrade tab snaps the chart to one second; later timeframe edits remain user controlled.
 * Off, Papertrade keeps the tab's stored timeframe like every other venue.
 */
export function resolveTabEntryTimeframe(
  exchange: Exchange,
  tabId: string | undefined,
  previousTabId: string | undefined,
  timeframe: number | undefined,
  enterAtOneSecond: boolean
): number | undefined {
  return enterAtOneSecond &&
    exchange === Exchange.EXCHANGE_PAPERTRADE &&
    tabId &&
    tabId !== previousTabId
    ? ChartTimeframe.CHART_TIMEFRAME_SEC_1
    : timeframe
}
